import { Modal } from '@medly-components/core';
import styled from 'styled-components';

export const PageLayoutStyled = styled('div')`
    display: grid;
    height: 100%;
    width: 100%;
    grid-template-areas:
        'aside header'
        'aside  main'
        'aside  footer';
    grid-template-rows: auto 1fr auto;
    grid-template-columns: auto 1fr;
    position: relative;

    & > aside {
        grid-area: aside;
    }

    & > header {
        grid-area: header;
    }

    & > main {
        grid-area: main;
        transition: width 200ms;
    }

    & > footer {
        grid-area: footer;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        display: flex;
        flex-direction: column;
        & > main {
            flex: 1;
        }

        ${Modal.Popup.Style} {
            max-height: calc(100% - 6.4rem);
        }
    }
`;
